<template>
    <!-- Main Content Start -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Grapes Sale List</h2>
        </div>
        
       <!-- Filter Form -->
<div class="card p-4 mb-4">
    <form @submit.prevent="filtergrapessale">
        <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">

          <!-- Start Date -->
          <div class="w-full lg:w-auto mt-4">
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input type="date" id="startDate" v-model="startDate" class="p-2 border border-gray-300 rounded w-full" />
        </div>
        
        <!-- End Date -->
        <div class="w-full lg:w-auto ml-2">
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input type="date" id="endDate" v-model="endDate" class="p-2 border border-gray-300 rounded w-full" />
        </div>

         <!-- Filter Button -->
         <div class="w-50 lg:w-auto ml-2">
            <button type="submit" class="btn b-solid btn-primary-solid px-5 cursor-pointer w-full lg:w-auto mt-2 lg:mt-6">Filter</button>
        </div>  

        
          <!-- Vendor Filter -->
            <div class="w-full lg:w-auto ml-2 mt-4"  style="width: 150px;">
                <label for="from_branch" class="block text-sm font-medium text-gray-700">Search Branch</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="from_branch" ref="from_branch" v-model="sale.from_branch">
                    <option value=""></option>
                    <option value="All">ALL</option>
                    <option v-for="(item, index) in branchList" :key="index" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
            
            <!-- Product Filter -->
            <div class="w-full lg:w-auto ml-2" style="width: 150px;">
                <label for="to_branch" class="block text-sm font-medium text-gray-700">Search Party</label>
                <select class="form-input w-full p-2 border border-gray-300 rounded" id="to_branch" ref="to_branch" v-model="sale.to_branch">
                    <option value=""></option>
                    <option value="All">ALL</option>
                    <option v-for="(item, index) in partyList" :key="index" :value="item.id">{{ item.name }}</option>
                </select>
            </div>  
            
           
        </div>
    </form>
</div> 
<!--<div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">-->
<!--    <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">-->
<!--        Export-->
<!--    </button>-->
<!--</div> -->

<div class="printonly">
    From {{startDate}} To {{endDate}}
</div>

<div class="card">
    <!-- Static heading -->
    <div id="printable-content">
        <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
        <h1 class="print-only" style="text-align: center;">Grapes Sale List</h1>
    </div>

    <button
        type="reset"
        @click="printReceipt"
        class="btn b-light btn-danger-light btn-sm"
    >
        Print
    </button>
    </div>






        <!-- Table Content -->
        <div class="grid grid-cols-12">
            <div class="col-span-full" v-if="isTableVisible">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                         <!-- RESPONSIVE WRAPPER -->
                         <div class="overflow-x-auto">
                        <table id="basicDataTable" class="datatable1 w-full min-w-[800px]">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Sr.No.</th>
                                    <th class="bg-[#B2E8D9]">Entry Date</th>
                                    <th class="bg-[#B2E8D9]">Leadger Name</th>
                                    <th class="bg-[#B2E8D9]">Branch Name</th>
                                    <th class="bg-[#B2E8D9]">Party Name</th>
                                    <th class="bg-[#B2E8D9]">Party Contact</th>
                                    <th class="bg-[#B2E8D9]">Party Address</th>
                                    <th class="bg-[#B2E8D9]">Driver Name</th>
                                    <th class="bg-[#B2E8D9]">Total KG</th>
                                    <th class="bg-[#B2E8D9]">Total Amount</th>
                                    <th class="bg-[#B2E8D9]">Paid Amount</th>
                                    <th class="bg-[#B2E8D9]">Due Amount</th>
                                    <th class="bg-[#B2E8D9]">Payment Type</th>
                                    <th class="bg-[#B2E8D9]">Note</th>
                                    <th class="bg-[#B2E8D9]">Operation</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index) in saleconsumptionList" :key="item.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ item.entry_date }}</td>
                                    <td>{{ item.leadger_name }}</td>
                                    <td>{{ item.branch_name }}</td>
                                    <td>{{ item.party_name }}</td>
                                    <td>{{ item.party_contact }}</td>
                                    <td>{{ item.party_address }}</td>
                                    <td>{{ item.drivername }}</td>
                                    <td>{{ item.totalkg }}</td>
                                    <td>{{ item.total_amount }}</td>
                                    <td>{{ item.paid_amount }}</td>
                                    <td>{{ parseInt(item.total_amount||0)-parseInt(item.paid_amount||0) }}</td>
                                    <td>{{ item.payment_type}}</td>
                                    <td>{{ item.note}}</td>
                                    <td>
                                        <div class="flex items-center gap-1">

                                            <button class="btn-icon btn-primary-icon-light size-7" @click="grapesView(item.id)">
                                                <i class="ri-edit-line text-success text-[13px]"></i>
                                            </button>

                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>

                                            <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.id)">
                                                <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                            </button>
                                        </div>
                                    </td>                           
                                </tr> 
                            </tbody>
                            <!-- Table Footer for Totals -->
                            <tfoot>
                                <tr>
                                  <td colspan="8" class="font-bold text-right">Total:</td>
                                  <td class="font-bold">{{ totalkghere }}</td>
                                  <td class="font-bold">{{ totalamount }}</td>
                                  <td class="font-bold">{{ paidamount }}</td>
                                  <td class="font-bold">{{ dueamount }}</td>
                                  <td class="font-bold"> </td>
                                  <td class="font-bold"> </td>
                                  <td class="font-bold"> </td>
                                </tr>
                              </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <!-- Main Content End -->


<!-- Start Delete Modal -->
<div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
    <div class="p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5 text-center">
                <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                <div class="mt-5 text-center">
                    <h5 class="mb-1">Are you sure?</h5>
                    <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                    <div class="flex justify-center gap-2 mt-6">
                        <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                        <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Delete Modal -->









</template>

<script>
import axios from 'axios';

export default {
    name: 'salarySlipReport',
    watch: {
        saleconsumptionList () { // data used in the table
           this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
             $('.datatable').DataTable().draw();
             this.reinitializeDataTable();
           })
         },
         
     },
    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            salslipList: [],
            branchList:[],
            partyList:[],
            saleconsumptionList:[],
            filteredsalslipList: [],
            stocktransferList:[],
            datatable: null,
            startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
            endDate: today,
            isTableVisible: false, // Initially table is hidden
            totalMale: 0,
            totalMaleAmount: 0,
            totalFemale: 0,
            totalFemaleAmount: 0,
            totalGadiAmount: 0,
            totalAmount: 0,
            sale: {
                from_branch: null,
                to_branch:null,
        },
        };
    },
    computed: {
        totalamount() {
  return Array.isArray(this.saleconsumptionList)
    ? parseFloat(
        this.saleconsumptionList.reduce(
          (total, item) => total + (parseFloat(item.total_amount) || 0),
          0
        ).toFixed(2)
      )
    : 0;
},

paidamount() {
  return parseFloat(
    this.saleconsumptionList.reduce(
      (total, item) =>
        total + (parseFloat(item.paid_amount || 0)),
      0
    ).toFixed(2)
  );
},
totalkghere() {
  return parseFloat(
    this.saleconsumptionList.reduce(
      (total, item) =>
        total + (parseFloat(item.totalkg || 0)),
      0
    ).toFixed(2)
  );
},

dueamount() {
  return parseFloat(
    this.saleconsumptionList.reduce(
      (total, item) =>
        total + (parseFloat(item.total_amount || 0) - parseFloat(item.paid_amount || 0) || 0),
      0
    ).toFixed(2)
  );
},

    },
    mounted() {
        //this.getBasics();
    },
    watch: {
        stocktransferList() {
            this.$nextTick(() => {
                $('.datatable').DataTable().draw();
           
            });
        },
    },
    methods: {

        print_invoice(id) {
            // alert("hello");
            window.open('/saleconsumptionreport?q=' + id, '_blank');
        },

        printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },
    grapesView(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/grapesView?q='+id, '_blank'); 
        },


        closeModal(){
        
        $("#editModal").addClass('hidden');
        $("#deleteModal").addClass('hidden');
            this.isAdd=0;
            this.isEdit=0;
            this.isDelete=0;
            this.deleteId=0;
            this.isAccount=0;
        },

        deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },


        getSalarySlipDetails(id) {
            window.open('/salaryslipdetails?q=' + id, '_blank');
        },
        exportToExcel() {
        // Prepare the CSV header
        const headers = ["entry_date", "branch_name", "party_name", "party_name", "paid_amount", "total_amount","payment_type","note"];
        const rows = this.saleconsumptionList.map(item => [
        this.formatDate(item.entry_date),
            item.branch_name,
            item.party_name,
            item.paid_amount,
            item.paid_amount,
            item.total_amount,
            item.payment_type,
            item.note,
        ]);

        // Combine headers and rows into a CSV string
        const csvContent = [headers, ...rows]
            .map(row => row.map(value => `"${value}"`).join(","))
            .join("\n");

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Trigger a download
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "Consumption_Report.csv");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
            formatDate(date) {
            if (!date) return "";  // Return empty string if date is missing or null
            const d = new Date(date);
            if (isNaN(d.getTime())) return "";  // Return empty if invalid date
            return d.toLocaleDateString();  // Format the date as per your requirement
        },
        calculateAmount(bhade, rate) {
            return (bhade * rate).toFixed(2);
        },
        async getBasics() {
            const self = this;
            axios.post('getconsumptionlist').then(function (response) {
                self.salslipList = response.data.salslipList;
                self.branchList = response.data.branchlist;
                self.partyList = response.data.partylist;
                self.stocktransferList = response.data.products;
                self.saleconsumptionList = response.data.saleconsumptionlists;
                self.original_saleconsumptionList = response.data.saleconsumptionlists;
            }).then(() => {


                $("#from_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                       // alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                            // self.saleconsumptionList.slice(0); 
                                            // if(event.target.value>0) {
                                            //     self.saleconsumptionList=self.original_saleconsumptionList.filter(item => item.branchid === event.target.value);
                                               
                                            // }else{
                                            //      self.saleconsumptionList=self.original_saleconsumptionList;
                                            // }    
                                            // $('.datatable').DataTable().destroy();                
                                            
                                        });


                                        $("#to_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search party Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {

                                        //  self.saleconsumptionList.slice(0); 
                                        //     if(event.target.value>0) {
                                        //         self.saleconsumptionList=self.original_saleconsumptionList.filter(item => item.partyid === event.target.value);
                                               
                                        //     }else{
                                        //         self.saleconsumptionList=self.original_saleconsumptionList;
                                        //     }
                                        //     $('.datatable').DataTable().destroy();
                                            
                                        });

            });
        },
        delete_category() {
           // alert("hello");
                var self = this; 
                axios.post('deletegrapes', {deleteId:this.deleteId})
                    .then(response => {
                      
                       // self.saleconsumptionList=response.data.saleconsumptionlists;
                        self. filtergrapessale();
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },




      
        filtergrapessale() {
            const self = this;
            axios.post('getgrapesList',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
                if ($.fn.dataTable.isDataTable('#basicDataTable')) {
                        $('#basicDataTable').DataTable().destroy();
                    }
                self.salslipList = response.data.salslipList;
                self.branchList = response.data.branchlist;
                self.partyList = response.data.partylist;
                self.stocktransferList = response.data.products;
                self.isTableVisible=true;
                self.saleconsumptionList = response.data.saleconsumptionlists;
                self.original_saleconsumptionList = response.data.saleconsumptionlists;
            }).then(() => {
                    $("#basicDataTable").DataTable({
                        ordering: false,
                dom: 'Bfrtip',
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );  // Disables automatic sorting
 

                $("#from_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Branch Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                       // alert(event.target.value);
                                            // self.sale.branchid=event.target.value; 
                                            //self.productsList.slice(0); 
                                            self.saleconsumptionList.slice(0); 
                                            if(event.target.value>0) {
                                                self.saleconsumptionList=self.original_saleconsumptionList.filter(item => item.branchid === event.target.value);
                                               
                                            }else{
                                                 self.saleconsumptionList=self.original_saleconsumptionList;
                                            }    
                                            $('.datatable').DataTable().destroy();                
                                            
                                        });


                                        $("#to_branch").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search party Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {

                                         self.saleconsumptionList.slice(0); 
                                            if(event.target.value>0) {
                                                self.saleconsumptionList=self.original_saleconsumptionList.filter(item => item.partyid === event.target.value);
                                               
                                            }else{
                                                self.saleconsumptionList=self.original_saleconsumptionList;
                                            }
                                            $('.datatable').DataTable().destroy();
                                            
                                        });

            });
        },

        },




 


        filterSalarySlip() {
            if (this.datatable) {
                this.datatable.destroy();
            }

            let filteredList = this.salslipList;
            if (this.startDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) >= new Date(this.startDate));
            }

            if (this.endDate) {
                filteredList = filteredList.filter(item => new Date(item.entrydate) <= new Date(this.endDate));
            }

            this.filteredsalslipList = filteredList;

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });
        },
        filterByParentName(parentName) {
            if (this.datatable) {
                this.datatable.destroy();
            }

            this.filteredsalslipList = this.salslipList.filter(item => item.parent_name === parentName);

            this.$nextTick(() => {
                this.datatable = $(".datatable").DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false
                });
            });

          
        },




      
    }

</script>


<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
            margin-top: -200px;
            display: block; 
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>